import script from "./CoinProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./CoinProgressBar.vue?vue&type=style&index=0&id=e223643c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e223643c"]])

export default __exports__